import React from 'react';
import {FormInstance} from 'antd';

export const DefaultColumnSize = 4;

interface ProFormContextProps {
    columns: number;
    form: FormInstance;
    disabled: boolean;
    noStyle?: boolean;
}

export const ProFormContextDefault: ProFormContextProps = {
    columns: DefaultColumnSize,
    form: {} as any,
    disabled: false,
    noStyle: false,
};

export const ProFormContext = React.createContext(ProFormContextDefault);
